import React, { useEffect, useState } from "react";
import axios from "axios";
import { parseAxiosError } from "../../../utils/response";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import MasterRefillingsFilter from "../../elements/masterRefilling/MasterRefillingsFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import Notification from "../../elements/notification/Notification";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { Helmet } from "react-helmet-async";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { useTranslation } from "react-i18next";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";
import MasterRefillingsList from "./MasterRefillingsList";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledMasterRefillingsWrapper } from "../styledMasterRefillings";

const MasterRefillingsContainer = () => {
  const { t } = useTranslation("masterRefillingsPage");
  const [refillings, setRefillings] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [fetch, setFetch] = useState(false);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "masterBalance.service.name": checkFilterItem(history, "masterBalance.service.name", null),
    "masterBalance.currency.asset": checkFilterItem(history, "masterBalance.currency.asset", null),
    "type": checkFilterItem(history, "type", null),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null),
    "amount[gte]": checkFilterItem(history, "amount[gte]", null),
    "amount[lte]": checkFilterItem(history, "amount[lte]", null),
    "user.email": checkFilterItem(history, "user.email", null),
    "id": checkFilterItem(history, "id", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchRefillings = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/master-refillings" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setRefillings(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchRefillings();
  }, [filterData, fetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledMasterRefillingsWrapper>
          <div className="master-refilling-head">
            <MasterRefillingsFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <MasterRefillingsList
            t={t}
            refillings={refillings}
            setNotification={setNotification}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledMasterRefillingsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default MasterRefillingsContainer;